import { useEffect, useState } from 'react';
import BasicPDFDocument from './BasicPDFDocument';
import { SourceDocument } from '../../types';
import PreviewBanner from './PreviewBanner';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { ANALYTICS_EVENTS } from '../../consts';
import useAnalytics from '../../hooks/useAnalytics';

type BasicPDFViewerProps = {
    sourceDocument: SourceDocument;
};

const BasicPDFViewer = (props: BasicPDFViewerProps) => {
    const { sendEvent } = useAnalytics();
    const [isShowFullDoc, setIsShowFullDoc] = useState<boolean>(false);
    const { t } = useTranslation();

    const onShowFullDocClick = () => {
        if (!isShowFullDoc) {
            sendEvent(ANALYTICS_EVENTS.SOURCE_FULL_DOCUMENT_CLICKED, {
                file: props.sourceDocument.metadata.filename,
                page: props.sourceDocument.metadata.page
            });
        }
        setIsShowFullDoc(!isShowFullDoc);
    };

    useEffect(() => {
        if (props.sourceDocument.metadata.source_pdf_preview_url === null) {
            setIsShowFullDoc(true);
        }
    }, [props.sourceDocument.metadata.source_pdf_preview_url]);

    const hasPreview = !!props.sourceDocument.metadata.source_pdf_preview_url;

    return (
        <>
            <PreviewBanner show={hasPreview}>
                <div className={classNames('pdf-viewer-iframe__banner')}>
                    {t('document.loading-doc-iframe')}
                    <div
                        className={classNames('pdf-viewer-iframe__btn')}
                        onClick={onShowFullDocClick}
                    >
                        <span className={classNames('pdf-viewer-iframe__icon')}>
                            &#8635;
                        </span>
                        {isShowFullDoc
                            ? t('document.loading-doc-iframe-btn')
                            : t('document.loading-preview-doc-iframe-btn')}
                    </div>
                </div>
            </PreviewBanner>
            <BasicPDFDocument
                key={props.sourceDocument.metadata?.page ?? 1}
                showDoc={true}
                sourcePath={
                    isShowFullDoc
                        ? props.sourceDocument.metadata?.source
                        : props.sourceDocument.metadata?.source_pdf_preview_url
                }
                pageNumber={
                    isShowFullDoc ? props.sourceDocument.metadata?.page : 1
                }
            />
        </>
    );
};

export default BasicPDFViewer;
